module.exports = __webpack_public_path__ + "static/img/01038B_3_4_C_20230601_LC.1970c7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/01038B_3_4_C_20230601_LC.png
// module id = /Ek3
// module chunks = 0